export const ContactSalesPageENUSTranslations = {
  contactSalesPageHeadDescription:
    'Ask us your questions. Talk to our experts.',
  contactSalesPageTitle:
    'Contact us and learn more about how we can help your business',
  contactSalesPageDescription:
    'Please fill out the form or use the button below to contact us via WhatsApp.',
  contactSalesPageWhatsAppButton: 'Contact us on WhatsApp',
};
